import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "estore-service";
const ORGANIZATION_SERVICE_URL = "organization-service";

export default {
    getUntaggedProducts: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/v1/cms/estore/product/brand/untagged_list/" +
                    param.uuid,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getTaggedProducts: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/v1/cms/estore/product/brand/tagged_list/" +
                    param.uuid,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveBrandBannerImage: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                ORGANIZATION_SERVICE_URL + "/brand/banner/save",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getBrandBannerImage: function(param) {
        return new Promise((resolve, reject) => {
            api.get(
                ORGANIZATION_SERVICE_URL + "/brand/view/" + param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getBranchList: function(param) {
        return new Promise((resolve, reject) => {
            api.get(
                ORGANIZATION_SERVICE_URL +
                    "/branch/list_per_brand/" +
                    param.uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    addStoreBrandProducts: function(param) {
        console.log(param)
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/estore/product/brand/in-queue/"+param.brand_uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    untagProducts: function(param) {
        return new Promise((resolve, reject) => {
            console.log(param)
            api.post(
                BASE_SERVICE_URL + "/v1/cms/estore/product/brand/untagging/in-queue/"+param.brand_uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getListProductInventoryByBranch: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/v1/cms/estore/product/inventory/" +
                    param.branchUuid +
                    "/list/" +
                    param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveBrandCategories: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/estore/product/brand/category/tag",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getBrandCategories: function(param) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/v1/cms/estore/product/brand/category/tagged_list/" +
                    param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveBrandProductCategory(param) {
        console.log(param.category_uuids)
        return new Promise((resolve, reject) => {
            api.post(
                "estore-service/v1/cms/estore/brand/save/" + param.uuid,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getBrandProductCategory(uuid) {
        console.log(uuid)
        return new Promise((resolve, reject) => {
            api.get(
                "estore-service/v1/cms/estore/brand/category/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateBranchPickupStatus: function(param) {
        return new Promise((resolve, reject) => {
            api.post(
                ORGANIZATION_SERVICE_URL + "/branch/pickup/status",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
